import React from 'react'
import { Form } from 'react-redux-form/immutable'
import { Fieldset, Row, Field } from 'react-gridforms'

import Input from 'components/Input'

const FormAdvising  = ({ legend }) => {
  return (
    <Form model="advisingState" className="grid-form">
      <Fieldset legend={legend} disabled>
        <Row>
          <Field span="2">
            <Input
              model=".student_id"
              label="ID Number"
            />
          </Field>
          <Field span="9">
            <Input
              model=".student_name"
              label="Name of Student"
            />
          </Field>
          <Field span="1">
            <Input
              model=".sex"
              label="Sex"
            />
          </Field>
        </Row>
        <Row>
          <Field span="2">
            <Input
              model=".course_code"
              label="Course/Major"
            />
          </Field>
          <Field span="1">
            <Input
              model=".level"
              label="Year Level"
            />
          </Field>
          <Field span="1">
            <Input
              model=".college_code"
              label="College"
            />
          </Field>
          <Field span="2">
            <Input
              model=".scholarship_code"
              label="Scholarship"
              disabled
            />
          </Field>
        </Row>
      </Fieldset>
    </Form>
  )
}

export default FormAdvising



// WEBPACK FOOTER //
// ./src/containers/Enrolment/form-advising.js